import React from 'react';

class FInput extends React.Component {
  constructor() {
    super();

    this._handleChange = this._handleChange.bind(this);
  }

  _handleChange(e) {
    let action = {
      type:       'TERM::CHANGE',
      value:      e.target.value,
      fireFilter: true
    };

    this.props.dispatchReducer(action);
  }

  render() {
    var value = this.props.data || '';
    var placeholderText = this.props.placeholderText || 'Enter a degree name';

    return <input type="text"
                  name="query-degree-name"
                  id="query-degree-name"
                  className="query"
                  placeholder={placeholderText}
                  defaultValue={value}
                  onChange={this._handleChange} />;
  }
}

FInput.propTypes = {
  data:            React.PropTypes.string.isRequired,
  dispatchReducer: React.PropTypes.func.isRequired
};

export default FInput;
